import GeneralService from "./GeneralService";
import { Component } from "react";

export class ModelService extends Component {
  public static getModels(loadingHandler: any, apiKey: string) {
    return GeneralService.get(
      "/model",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static disableModel(
    modelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/model/${modelId}/disable`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static enableModel(
    modelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/model/${modelId}/enable`,
      JSON.stringify({}),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getModelsByIntentGroup(
    intentGroupId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/model/intent_group/${intentGroupId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getModelsByApplication(
    applicationId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/model/application/${applicationId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
  public static getModelsByIntent(
    intentId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/model/intent/${intentId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
